/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {apiUrl, handleApiCall} from './HttpUtils'

import {LIST_ORDER} from '../utils/Const'

const composeUserQuery = (search, sort, sortOrder) => {
    let query = '?start=0';
    if (search && search.length > 0) {
        query += '&search=' + encodeURIComponent(search)
    }
    if (sort && sort.length > 0) {
        query += '&sort=' + encodeURIComponent(sort)
    }
    query += '&sortOrder='
    let sortOrdering = LIST_ORDER.ASC
    if (sortOrder === -1) {
        sortOrdering = LIST_ORDER.DESC
    }
    query += sortOrdering

    return query
}

const getRolesApiUrl = (search, sort, sortOrder) => {
    return apiUrl(`roles`) + composeUserQuery(search, sort, sortOrder)
}

export const fetchRoles = (search, sort, sortOrder) => {
    return handleApiCall(getRolesApiUrl(search, sort, sortOrder))
}
